import type { ComponentType } from 'react'
import {
  DeploymentDiagram,
  AwsTopologyDiagram,
  ConnectionFlowDiagram,
  PatientJourneyDiagram,
  Hl7IntegrationDiagram,
  TrustZonesDiagram,
  CiCdDiagram,
  ScalingDiagram,
  PurchaseOrderLifecycleDiagram,
} from './diagrams'
import { CICD_FLOW, CONNECTION_FLOW, HL7_FLOW, PO_LIFECYCLE_FLOW } from '@/help/architecture/flows'
import { DiagramViewer } from './DiagramViewer'
import { FlowStepper } from './FlowStepper'
import { SystemMap } from './SystemMap'

/** A ```diagram block renders the entry named by its body, given a title derived from that name. */
type DiagramEntry = ComponentType<{ title: string }>

/** A static diagram in the standard frame (fullscreen + legend). */
function framed(Diagram: ComponentType): DiagramEntry {
  return function FramedDiagram({ title }) {
    return (
      <DiagramViewer title={title}>
        <Diagram />
      </DiagramViewer>
    )
  }
}

export const DIAGRAM_REGISTRY: Record<string, DiagramEntry> = {
  'system-map': () => <SystemMap />,
  'deployment-overview': framed(DeploymentDiagram),
  'aws-topology': framed(AwsTopologyDiagram),
  'connection-flow': ({ title }) => <FlowStepper title={title} steps={CONNECTION_FLOW} Diagram={ConnectionFlowDiagram} />,
  'patient-journey': framed(PatientJourneyDiagram),
  'hl7-integration': ({ title }) => <FlowStepper title={title} steps={HL7_FLOW} Diagram={Hl7IntegrationDiagram} />,
  'trust-zones': framed(TrustZonesDiagram),
  'cicd-pipeline': ({ title }) => <FlowStepper title={title} steps={CICD_FLOW} Diagram={CiCdDiagram} />,
  'scaling-architecture': framed(ScalingDiagram),
  'purchase-order-lifecycle': ({ title }) => (
    <FlowStepper title={title} steps={PO_LIFECYCLE_FLOW} Diagram={PurchaseOrderLifecycleDiagram} />
  ),
}
